import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKenticoComponent } from './simple-icons-kentico.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKenticoComponent ],
    exports:      [ SimpleIconsKenticoComponent ],
    bootstrap:    []
})
export class SimpleIconsKenticoModule {}
